import { Grid } from '../../../primitives/grid/Grid';
import { useBarData } from '../providers/data';
import { jsx as _jsx } from "react/jsx-runtime";
export function BarGrid() {
  const {
    xScale,
    yScale,
    height,
    width
  } = useBarData();
  return /*#__PURE__*/_jsx(Grid, {
    rowLineStyle: "solid",
    columnLineStyle: "hidden",
    xScale: xScale,
    yScale: yScale,
    width: width,
    height: height
  });
}